import React from 'react';
import { Box, Typography } from '@trp-individual-investor-adv-svc/ii-prosp-components';
import { FPSClientAgreement } from '../shared/Links';
import PdfLinks from '../shared/PdfLinks';
import GenericPanel from './GenericPanel';
import {
    PsBeaconButton,
    PsBeaconControl,
    PsBeaconControlGroup,
    PsBeaconError,
} from '../shared/BeaconRegister';
import LoadingSpinner from '../../containers/LoadingSpinner';
import { ClientAgrContent } from './ConsentContent';

const ClientAgrPanel = ({
    panelNum,
    headerText = 'Client Agreement and Planning Supplement, ADV, Forms CRS and Privacy Notice',
    handleChange,
    checkError,
    checkBox,
    onClick,
    inProgress = false,
    isCustomerWebView,
    open,
}) => {
    return (
        <GenericPanel
            headerText={
                <>
                    <span>
                        {panelNum}. {headerText}
                    </span>
                    {checkError?.checkedAdv && (
                        <Box>
                            <PsBeaconError id="client-agreement-field-error">
                                Please fill in all required fields to continue.
                            </PsBeaconError>
                        </Box>
                    )}
                </>
            }
            id="client-agreement-container"
            open={open}>
            <Typography
                id={ClientAgrContent.headerId}
                type="body" loose scale={100} bold>
                <span
                    dangerouslySetInnerHTML={{
                        __html: ClientAgrContent.header,
                    }}
                />
            </Typography>
            <Typography
                id="client-agreement-text"
                type="body" loose scale={100} light
                sx={{ paddingBottom: '40px' }}
            />

            <Box id="investment-release-text" sx={{ paddingBottom: '40px' }}>
                <span
                    dangerouslySetInnerHTML={{
                        __html: ClientAgrContent.includeInvestmentRelease,
                    }}
                />
            </Box>
            <Box id="investment-client-agreement-forms-container" sx={{ paddingBottom: '24px' }}>
                {FPSClientAgreement.map((pdfLink) => (
                    <PdfLinks
                        key={pdfLink.name}
                        showPdfIcon={pdfLink.showPdfIcon}
                        pdfLink={pdfLink.agreementLink}
                        fundName={`${pdfLink.name} (PDF)`}
                        linkId={pdfLink.linkId}
                        singleCol
                    />
                ))}
            </Box>
            <Box id="print-agreement-reminder" sx={{ paddingBottom: '40px' }}>
                {ClientAgrContent.authorizeInvHoldings}
            </Box>

            {checkBox && (
                <PsBeaconControlGroup style={{ paddingBottom: '40px' }}>
                    <PsBeaconControl inline id="client-agreement-control" required>
                        <label slot="label" id="agreementAdv-label" htmlFor="agreementAdv" required>
                            I agree
                        </label>
                        <input
                            type="checkbox"
                            name="agreementAdv"
                            id="agreementAdv"
                            required
                            onChange={handleChange('checkedAdv')}
                        />
                        <div slot="error">This field is required.</div>
                    </PsBeaconControl>
                </PsBeaconControlGroup>
            )}

            {onClick && (
                <PsBeaconButton
                    id="i-agree-button"
                    variant="primary"
                    onClick={!inProgress && onClick}
                    disabled={isCustomerWebView}>
                    {!inProgress && 'I Agree'}
                    {inProgress && <LoadingSpinner scale="mini" text="Loading..." />}
                </PsBeaconButton>
            )}
        </GenericPanel>
    );
};

export default ClientAgrPanel;
